import { render, staticRenderFns } from "./SDAClientInfo.vue?vue&type=template&id=7e6a3496"
import script from "./SDAClientInfo.vue?vue&type=script&lang=js"
export * from "./SDAClientInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports